;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();export enum UserRole {
  ADMIN = 'admin',
  EMPLOYER = 'employer',
  EMPLOYEE = 'employee',
  CONTRACTOR = 'contractor',
  ORGANISATION_OWNER = 'organisation_owner',
  INVOICE_MANAGER = 'invoice_manager',
  EMPLOYMENT_MANAGER = 'employment_manager',
  ORGANISATION_ADMIN = 'organisation_admin',
}

export const ALLOWED_INCORPORATION_COUNTRIES = [
  'AU',
  'BE',
  'BG',
  'CY',
  'DE',
  'IE',
  'MT',
  'PH',
  'HK',
  'HR',
  'US',
  'GB',
  'SE',
  'UK',
] as const;
